/* eslint-disable */
import { API } from 'aws-amplify';
import CryptoJS from 'crypto-js';

/**
 * Css Node Selector
 */
const getCSSSelector = (el) => {
  try {
    let selector = el.tagName.toLowerCase();
    const attrs = el.attributes;
    const cases = {
      id: ({ value }) => {
        selector += `#${value}`
      },
      class: ({ value }) => {
        selector += value
          .split(' ')
          .map((c) => (!c ? '' : `.${c}`))
          .join('');
      },
      name: ({ name, value }) => {
        selector += `[${name}=${value}]`;
      },
    };

    for (let i = 0; i < attrs.length; i++) {
      const attr = attrs.item(i);
      const handling = cases[attr.name];

      if (handling) {
        handling(attr);
      }
    }
    return selector;
  } catch (error) {
    console.error(error);
    return '';
  }
};

const getParentsSelector = (elem) => {
  try {
    let parents = [];
    for (; elem && elem !== document; elem = elem.parentNode) {
      parents.push(elem);
    }
    return parents.reverse();
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getQuerySelector = (child) => {
  try {
    const parents = getParentsSelector(child);
    return parents.map((parent) => getCSSSelector(parent)).join(' > ');
  } catch (error) {
    console.error(error);
    return '';
  }
};

/**
 * Utilities
 */
export const isEmpty = (value) =>
  [null, undefined, true, false].includes(value) ||
  value.length === 0 ||
  (Object.keys(value).length === 0 && value.constructor === Object);

export const getUrlConsume = async (name, path) => {
  try {
    const url = await API.endpoint(name);
    return `${url}${path}`.trim();
  } catch (error) {
    console.error(error);
    return path;
  }
};

export const getUrlClient = async () => window.location?.href;

/**
 * Form helpers
 */
export const getDataForm = () => {
  const forms = document.forms;
  let dataForm = [];
  if (!!forms) {
    const formElement = document.forms[0];
    if (formElement) {
      const children = Array.from(formElement || []);
      dataForm = children.map((item) => [item.id, item.value]);
    }
  }
  return Object.fromEntries(dataForm);
};

export const getValueOfForm = (type) => {
  const data = getDataForm();
  let value = '';
  Object.keys(data).forEach((key) => {
    if (key.includes(type)) {
      return (value = data[key]);
    }
  });
  return value;
};

export const getLocalCardMask = (card) => {
  const cardNumber = String(card).replace(/\s+/g, '');
  const part1 = cardNumber.substring(6, -1);
  const part2 = cardNumber.substring(cardNumber.length - 4, cardNumber.length);
  const partMask = cardNumber.length - 10;
  const mask = new Array(partMask < 0 ? 0 : partMask).fill('*');
  return [part1, ...mask, part2].join('');
};

/**
 * Error helpers
 */
export const getLineError = (error) => {
  const stackLine = error?.stack?.split('\n');
  if (Array.isArray(stackLine)) {
    return stackLine.find((line) => line.includes('http'));
  }
  return '';
};

export const getError = (code, message, line, isCrash) => ({
  error: {
    code,
    message,
    line,
    isCrash
  },
});

/**
 * Amplify helpers
 */
export async function AmplifyApi(request) {
  const req = Object.assign(request);
  try {
    const response = await API.post(req.name, req.path, req.data);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

const getTrace = () => {
  return {
    serviceId: 'api-cotizar-multicanal-ami',
    consumerId: 'WEBPUB',
    channelCode: 'WEB',
    traceId: String((new Date()).getTime()),
  }
};

export const converterRequest = (data) => ({
  body: {
    request: {
      trace: getTrace(),
      payload: data,
    }
  }
});

export const getDevice = () => {
  try {
    let parts = navigator.userAgent.split(/\s*[;)(]\s*/);
    const browser = (parts?.[parts.length-1] || '').replace(/Gecko.* /, '').replace(/Version.* /,'');
    const so = navigator.userAgent.replace(/\).*/, '').replace(/.*\(/, '');

    let cleanBrowser = browser;

    if ((browser || '').includes('OPR')) {
      cleanBrowser = browser.replace(/.*OPR/, 'OPR');
    } else if ((browser || '').includes('EdgiOS')) {
      cleanBrowser = browser.replace(/Safari.*/, '');
    } else if ((browser || '').includes('Edg')) {
      cleanBrowser = browser.replace(/.*Edg/, 'Edg');
    } else if ((browser || '').includes('CriOS')) {
      cleanBrowser = browser.replace(/Safari.*/, '');
    } else if ((browser || '').includes('FxiOS')) {
      cleanBrowser = browser.replace(/Safari.*/, '');
    } else {
      if ((browser || '').includes('Chrome')) {
        cleanBrowser = browser.replace(/Safari.*/, '');
      }
    }

    return `OS: ${so} | Browser: ${cleanBrowser.trim()}`;
  } catch (error) {
    console.error(error);
    return 'OS: | Browser: ';
  }
};


export function hashUser(docType, docNumber, cookieKey) {
  const APIkey = cookieKey;
  const hash = CryptoJS.HmacSHA256(docNumber, APIkey);
  return `${docType}-${hash.toString()}`;
}

export function hash(data, cookieKey) {
  const APIkey = cookieKey;
  const hash = CryptoJS.HmacSHA256(data, APIkey);
  return `${hash.toString()}`;
}

export function JVDError(message, name) {
  let temp = Error.apply(this, arguments);
  temp.name = this.name = name;
  this.message = `${name}|${message}`;
  if (Object.defineProperty) {
    Object.defineProperty(this, 'stack', {
      get() {
        return temp.stack;
      },
      configurable: true,
    });
  } else {
    this.stack = temp.stack;
  }
}

export function dynamicGetTraceId(response = {}, dataDecript = {}) {
  if (isEmpty(response) && isEmpty(dataDecript)) {
    return '';
  }

  const traceIdV1 = response?.response?.trace?.traceId;
  const traceIdV2 = response?.payload?.trace?.traceId;
  const traceIdV3 = dataDecript?.trace?.traceId;

  return traceIdV1 || traceIdV2 || traceIdV3;
}

export function dynamicErrorTraceId(response = {}) {
  if (isEmpty(response)) {
    return '';
  }

  const traceIdV1 = response?.response?.trace?.traceId;
  const traceIdV2 = response?.payload?.trace?.traceId;
  const traceIdV3 = response?.trace?.traceId;
  const traceIdV4 = response?.error?.trace?.traceId;
  const traceIdV5 = response?.error?.traceId;
  const traceIdV6 = response?.status?.error?.trace?.traceId;
  const traceIdV7 = response?.response?.status?.error?.trace?.traceId;

  return traceIdV1 || traceIdV2 || traceIdV3 || traceIdV4 || traceIdV5 || traceIdV6 || traceIdV7;
}
